import { inject, Injectable, injectAsync } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslocoService } from '@jsverse/transloco';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private updates = inject(SwUpdate);
  private transloco = inject(TranslocoService);
  private matSnackbar = injectAsync(() => import('@angular/material/snack-bar').then((m) => m.MatSnackBar));

  constructor() {
    this.updates.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.promptUser();
      }
    });
  }

  init() {
    if (this.updates.isEnabled) {
      setInterval(() => this.updates.checkForUpdate(), environment.swCheckTime * 1000);
    }
  }

  private async promptUser() {
    (await this.matSnackbar())
      .open(this.transloco.translate('PAGE_UPDATED_PLEASE_RELOAD'), this.transloco.translate('RELOAD_PAGE'))
      .afterDismissed()
      .subscribe(() => window.location.reload());
  }
}
